export default ({ request }) => ({
  sysOrganizationListApi(data = {}) {
    return request({
      url: '/sys/organization/list',
      method: 'post',
      data,
    })
  },
  sysOrganizationDelApi(data = {}) {
    return request({
      url: '/sys/organization/del',
      method: 'post',
      data,
    })
  },
  sysOrganizationDetailApi(data = {}) {
    return request({
      url: '/sys/organization/detail',
      method: 'post',
      data,
    })
  },
  sysOrganizationSaveApi(data = {}) {
    return request({
      url: '/sys/organization/save',
      method: 'post',
      data,
    })
  },
})
